package ru.villawonka.app.presentation.screens.postCard.compose

import androidx.compose.runtime.*
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.bottomSheet.LocalBottomSheetNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.core.parameter.parametersOf
import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.getTelegram
import ru.villawonka.app.presentation.screens.conversationDetails.compose.ConversationDetailsScreen
import ru.villawonka.app.presentation.screens.photoSlider.compose.PhotoSliderScreen
import ru.villawonka.app.presentation.screens.postCard.compose.layout.PostCardRootLayout
import ru.villawonka.app.presentation.screens.postCard.viewmodel.PostCardUIEvent
import ru.villawonka.app.presentation.screens.postCard.viewmodel.PostCardUIState
import ru.villawonka.app.presentation.screens.postCard.viewmodel.PostCardViewModel

class PostCardScreen(
    private val postId: Int,
    private val postType: PostTypeDomain,
) : Screen {

    @Composable
    override fun Content() {
        val viewModel = koinScreenModel<PostCardViewModel> { parametersOf(postId, postType) }
        val navigator = LocalNavigator.currentOrThrow
        val bottomSheetNavigator = LocalBottomSheetNavigator.current
        val state by viewModel.uiState.collectAsState(initial = PostCardUIState.Loading)

        PostCardRootLayout(
            state = state,
            callbacks = remember {
                PostCardCallbacks(
                    onChatClick = viewModel::onChatClick,
                    onImageClick = viewModel::onImageClick,
                    onLikeClick = viewModel::onLikeClick,
                    onShareClick = viewModel::onShareClick,
                    onSendReportClick = viewModel::onSendReportClick,
                    onConversationDetailsClick = viewModel::onConversationDetailsClick,
                    onGoToSourceClick = viewModel::onGoToSourceClick,
                    onRetryLoad = viewModel::onRetryLoadClick
                )
            }
        )

        LaunchedEffect(Unit) {
            viewModel.events.collect { event ->
                when (event) {
                    is PostCardUIEvent.OpenExternalLink ->
                        getTelegram()?.openTelegramLink(event.link)
                    is PostCardUIEvent.OpenPhotoSliderScreen ->
                        navigator.push(PhotoSliderScreen(
                            initialPage = event.initialPage,
                            photos = event.photos
                        ))
                    is PostCardUIEvent.OpenConversationDetailsScreen ->
                        bottomSheetNavigator.show(ConversationDetailsScreen(event.conversationDetails))
                    is PostCardUIEvent.OpenSendReportScreen -> Unit
                }
            }
        }
    }
}

data class PostCardCallbacks(
    val onImageClick: (selectedIndex: Int) -> Unit,
    val onShareClick: () -> Unit,
    val onChatClick: () -> Unit,
    val onLikeClick: (Boolean) -> Unit,
    val onSendReportClick: () -> Unit,
    val onConversationDetailsClick: () -> Unit,
    val onGoToSourceClick: () -> Unit,
    val onRetryLoad: () -> Unit
)